/**
 * @file 侧边导航
 * @author sunyingying01
 */

import React from 'react';
import {observer} from 'mobx-react-lite';
import cx from 'classnames';
import CollapsedBtn from '@components/CollapsedBtn';

import {SiderNavigationStore} from '@/stores';
import styles from './index.module.less';

interface IProps {
    store: SiderNavigationStore;
    children?: React.ReactNode;
}
const logoUrl = 'https://now.bdstatic.com/stash/v1/84b278a/fm-console-fe/65c99cd/img/famou_logo.svg';
const CustomSider: React.FC<IProps> = props => (
    <div
        className={cx(styles.sider, {
            [styles.collapsed]: props.store.collapsed
        })}
    >
        <div className={styles.siderHeader}>
            <img src={logoUrl} alt="logo" className={styles.logoImg} />
            {/* <span className={styles.siderTitle}>管理平台</span> */}
            <CollapsedBtn store={props.store} />
        </div>
        {props.children}
    </div>
);

export default observer(CustomSider);


